import axios from '../../utils/axios';

const getPartnerRole = async (partnerId) => {
  try {
    const response = await axios({
      method: 'get',
      url: `/users/partner-role?partner=${partnerId}`,
    });
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getPartnerRole };
